// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"517a7da1","453":"67c7a866","732":"b0179b3c","977":"6f9bf92b"}[chunkId] + ".chunk.js";
};